/** CoStar.Api.ListingMarketplace.MarketingCategoryListingCount.ViewModels.AddressFieldType */
export var AddressFieldType;
(function (AddressFieldType) {
    AddressFieldType[AddressFieldType["None"] = 0] = "None";
    AddressFieldType[AddressFieldType["State"] = 1] = "State";
    AddressFieldType[AddressFieldType["City"] = 2] = "City";
    AddressFieldType[AddressFieldType["Postcode"] = 3] = "Postcode";
    AddressFieldType[AddressFieldType["Submarket"] = 4] = "Submarket";
    AddressFieldType[AddressFieldType["County"] = 5] = "County";
    AddressFieldType[AddressFieldType["Metro"] = 6] = "Metro";
    AddressFieldType[AddressFieldType["ResearchMarket"] = 7] = "ResearchMarket";
    AddressFieldType[AddressFieldType["PostcodePart"] = 8] = "PostcodePart";
    AddressFieldType[AddressFieldType["College"] = 11] = "College";
    AddressFieldType[AddressFieldType["MilitaryBase"] = 12] = "MilitaryBase";
    AddressFieldType[AddressFieldType["ParksAndRec"] = 13] = "ParksAndRec";
    AddressFieldType[AddressFieldType["Cluster"] = 14] = "Cluster";
})(AddressFieldType || (AddressFieldType = {}));
/** @deprecated Please pass in the marketing category ID instead. */
/** CoStar.Api.ListingMarketplace.MarketingCategoryListingCount.ViewModels.MarketingCategory */
export var MarketingCategory;
(function (MarketingCategory) {
    MarketingCategory[MarketingCategory["None"] = 0] = "None";
    MarketingCategory[MarketingCategory["TenThirtyOneExchange"] = 1] = "TenThirtyOneExchange";
    MarketingCategory[MarketingCategory["AirplaneHangar"] = 2] = "AirplaneHangar";
    /** @deprecated Please use Airplane Hangar or Airport instead. */
    MarketingCategory[MarketingCategory["Airport"] = 3] = "Airport";
    MarketingCategory[MarketingCategory["AmusementPark"] = 4] = "AmusementPark";
    MarketingCategory[MarketingCategory["ApartmentBuilding"] = 5] = "ApartmentBuilding";
    MarketingCategory[MarketingCategory["AutomotiveProperty"] = 6] = "AutomotiveProperty";
    MarketingCategory[MarketingCategory["Bank"] = 7] = "Bank";
    MarketingCategory[MarketingCategory["BankOwnedProperty"] = 8] = "BankOwnedProperty";
    MarketingCategory[MarketingCategory["Bar"] = 9] = "Bar";
    MarketingCategory[MarketingCategory["BowlingAlley"] = 10] = "BowlingAlley";
    MarketingCategory[MarketingCategory["Business"] = 11] = "Business";
    MarketingCategory[MarketingCategory["CarWash"] = 12] = "CarWash";
    /** @deprecated Please use Sports and Entertainment Property instead. */
    MarketingCategory[MarketingCategory["Casino"] = 13] = "Casino";
    MarketingCategory[MarketingCategory["CemeteryOrMausoleum"] = 14] = "CemeteryOrMausoleum";
    MarketingCategory[MarketingCategory["Church"] = 15] = "Church";
    MarketingCategory[MarketingCategory["CoinLaundryOrLaundromat"] = 16] = "CoinLaundryOrLaundromat";
    MarketingCategory[MarketingCategory["CommercialLand"] = 17] = "CommercialLand";
    MarketingCategory[MarketingCategory["ConvenienceStore"] = 18] = "ConvenienceStore";
    MarketingCategory[MarketingCategory["DayCareCenter"] = 19] = "DayCareCenter";
    MarketingCategory[MarketingCategory["DepartmentStore"] = 20] = "DepartmentStore";
    MarketingCategory[MarketingCategory["DistributionProperty"] = 21] = "DistributionProperty";
    MarketingCategory[MarketingCategory["Dormitory"] = 22] = "Dormitory";
    MarketingCategory[MarketingCategory["DrugStore"] = 23] = "DrugStore";
    MarketingCategory[MarketingCategory["Farm"] = 24] = "Farm";
    MarketingCategory[MarketingCategory["FastFoodRestaurant"] = 25] = "FastFoodRestaurant";
    MarketingCategory[MarketingCategory["FlexSpace"] = 26] = "FlexSpace";
    MarketingCategory[MarketingCategory["FoodProcessingProperty"] = 27] = "FoodProcessingProperty";
    MarketingCategory[MarketingCategory["FuneralHome"] = 28] = "FuneralHome";
    MarketingCategory[MarketingCategory["GardenCenterOrNursery"] = 29] = "GardenCenterOrNursery";
    MarketingCategory[MarketingCategory["GasStation"] = 30] = "GasStation";
    MarketingCategory[MarketingCategory["GolfCourse"] = 31] = "GolfCourse";
    MarketingCategory[MarketingCategory["GovernmentProperty"] = 32] = "GovernmentProperty";
    /** @deprecated Please use Sports and Entertainment Property instead. */
    MarketingCategory[MarketingCategory["GymOrHealthClub"] = 33] = "GymOrHealthClub";
    MarketingCategory[MarketingCategory["HealthCareProperty"] = 34] = "HealthCareProperty";
    MarketingCategory[MarketingCategory["HorseProperty"] = 35] = "HorseProperty";
    MarketingCategory[MarketingCategory["Hospital"] = 36] = "Hospital";
    MarketingCategory[MarketingCategory["Hotel"] = 37] = "Hotel";
    MarketingCategory[MarketingCategory["IndustrialLand"] = 38] = "IndustrialLand";
    MarketingCategory[MarketingCategory["IndustrialProperty"] = 39] = "IndustrialProperty";
    MarketingCategory[MarketingCategory["Land"] = 40] = "Land";
    MarketingCategory[MarketingCategory["Landfill"] = 41] = "Landfill";
    MarketingCategory[MarketingCategory["LiveWorkSpace"] = 42] = "LiveWorkSpace";
    MarketingCategory[MarketingCategory["Lodge"] = 43] = "Lodge";
    MarketingCategory[MarketingCategory["Loft"] = 44] = "Loft";
    MarketingCategory[MarketingCategory["ManufacturingProperty"] = 45] = "ManufacturingProperty";
    MarketingCategory[MarketingCategory["Marina"] = 46] = "Marina";
    MarketingCategory[MarketingCategory["MedicalOffice"] = 47] = "MedicalOffice";
    MarketingCategory[MarketingCategory["MobileHomeRVPark"] = 48] = "MobileHomeRVPark";
    MarketingCategory[MarketingCategory["Motel"] = 49] = "Motel";
    MarketingCategory[MarketingCategory["MultifamilyProperty"] = 50] = "MultifamilyProperty";
    MarketingCategory[MarketingCategory["TripleNetProperty"] = 51] = "TripleNetProperty";
    MarketingCategory[MarketingCategory["OfficeSpace"] = 52] = "OfficeSpace";
    MarketingCategory[MarketingCategory["OwnerFinancedProperty"] = 53] = "OwnerFinancedProperty";
    MarketingCategory[MarketingCategory["ParkingGarage"] = 54] = "ParkingGarage";
    /** @deprecated Please use Parking Lot or Garage instead. */
    MarketingCategory[MarketingCategory["ParkingLot"] = 55] = "ParkingLot";
    MarketingCategory[MarketingCategory["PoliceOrFireStation"] = 56] = "PoliceOrFireStation";
    MarketingCategory[MarketingCategory["PostOffice"] = 57] = "PostOffice";
    MarketingCategory[MarketingCategory["ResearchAndDevelopmentProperty"] = 58] = "ResearchAndDevelopmentProperty";
    MarketingCategory[MarketingCategory["RecreationalLand"] = 59] = "RecreationalLand";
    MarketingCategory[MarketingCategory["RefrigerationOrColdStorageProperty"] = 60] = "RefrigerationOrColdStorageProperty";
    MarketingCategory[MarketingCategory["ResidentialIncomeProperty"] = 61] = "ResidentialIncomeProperty";
    MarketingCategory[MarketingCategory["ResidentialLand"] = 62] = "ResidentialLand";
    MarketingCategory[MarketingCategory["Restaurant"] = 63] = "Restaurant";
    MarketingCategory[MarketingCategory["RetailLand"] = 64] = "RetailLand";
    MarketingCategory[MarketingCategory["RetailSpace"] = 65] = "RetailSpace";
    MarketingCategory[MarketingCategory["School"] = 66] = "School";
    MarketingCategory[MarketingCategory["SelfStorageFacility"] = 67] = "SelfStorageFacility";
    MarketingCategory[MarketingCategory["SeniorHousing"] = 68] = "SeniorHousing";
    MarketingCategory[MarketingCategory["Showroom"] = 69] = "Showroom";
    MarketingCategory[MarketingCategory["SkatingRink"] = 70] = "SkatingRink";
    MarketingCategory[MarketingCategory["StorefrontProperty"] = 71] = "StorefrontProperty";
    MarketingCategory[MarketingCategory["Studio"] = 72] = "Studio";
    MarketingCategory[MarketingCategory["Supermarket"] = 73] = "Supermarket";
    MarketingCategory[MarketingCategory["TelecomProperty"] = 74] = "TelecomProperty";
    MarketingCategory[MarketingCategory["Theater"] = 75] = "Theater";
    MarketingCategory[MarketingCategory["TruckStop"] = 76] = "TruckStop";
    /** @deprecated Please use Truck Stop or Truck Terminal instead. */
    MarketingCategory[MarketingCategory["TruckTerminal"] = 77] = "TruckTerminal";
    MarketingCategory[MarketingCategory["VeterinarianOrKennelProperty"] = 78] = "VeterinarianOrKennelProperty";
    MarketingCategory[MarketingCategory["Vineyard"] = 79] = "Vineyard";
    MarketingCategory[MarketingCategory["Warehouse"] = 80] = "Warehouse";
    MarketingCategory[MarketingCategory["SportsAndEntertainmentProperty"] = 81] = "SportsAndEntertainmentProperty";
    MarketingCategory[MarketingCategory["Acreage"] = 82] = "Acreage";
    MarketingCategory[MarketingCategory["AuctionLand"] = 83] = "AuctionLand";
    MarketingCategory[MarketingCategory["CommercialAuction"] = 84] = "CommercialAuction";
    MarketingCategory[MarketingCategory["CommercialRealEstateForeclosure"] = 85] = "CommercialRealEstateForeclosure";
    MarketingCategory[MarketingCategory["Lot"] = 86] = "Lot";
    MarketingCategory[MarketingCategory["ShoppingCenter"] = 87] = "ShoppingCenter";
    MarketingCategory[MarketingCategory["Shop"] = 88] = "Shop";
    MarketingCategory[MarketingCategory["ExecutiveSuite"] = 89] = "ExecutiveSuite";
    MarketingCategory[MarketingCategory["DuplexTriplexFourplex"] = 90] = "DuplexTriplexFourplex";
    MarketingCategory[MarketingCategory["IncomeProperty"] = 91] = "IncomeProperty";
    MarketingCategory[MarketingCategory["FarmAuction"] = 92] = "FarmAuction";
})(MarketingCategory || (MarketingCategory = {}));
/** CoStar.Api.ListingMarketplace.MarketingCategoryListingCount.ViewModels.MarketingBrands */
export var MarketingBrands;
(function (MarketingBrands) {
    MarketingBrands[MarketingBrands["None"] = 0] = "None";
    MarketingBrands[MarketingBrands["LoopNet"] = 1] = "LoopNet";
    MarketingBrands[MarketingBrands["CityFeet"] = 2] = "CityFeet";
    MarketingBrands[MarketingBrands["Showcase"] = 4] = "Showcase";
})(MarketingBrands || (MarketingBrands = {}));
/** CoStar.Api.ListingMarketplace.MarketingCategoryListingCount.ViewModels.LeaseSaleType */
export var LeaseSaleType;
(function (LeaseSaleType) {
    LeaseSaleType[LeaseSaleType["None"] = 0] = "None";
    LeaseSaleType[LeaseSaleType["Lease"] = 1] = "Lease";
    LeaseSaleType[LeaseSaleType["Sale"] = 2] = "Sale";
})(LeaseSaleType || (LeaseSaleType = {}));
/** CoStar.Api.ListingMarketplace.MarketingCategoryListingCount.ViewModels.Sort */
export var Sort;
(function (Sort) {
    Sort[Sort["None"] = 0] = "None";
    Sort[Sort["Alphabetical"] = 1] = "Alphabetical";
    Sort[Sort["ListingCount"] = 2] = "ListingCount";
})(Sort || (Sort = {}));
